import React from 'react';
import "./dashboardEnvData.css"
import temperatureIcon from "../../../assets/temperatureIcon.svg";

const DashboardEnvData = () => {
    return (
        <div className='dashboardEnvDataMainContainer'>
            <div style={{marginLeft:"-7px"}} className='dashboardEnvDataTopContainer'>
            <span><img className='temperatureIcon' src={temperatureIcon} alt="temperatureIcon" /></span>
                <p className='EnvDataHeading'>Environment Data</p>
            </div>
            <div className='dashboardEnvDataBottomContainer'>
                <div className="envDataLeftContainer">
                    <p className='Temperature'>Temperature</p>
                    <p className='TemperatureInfo'>40°C</p>
                </div>
                <div className="envDatarightContainer">
                    <p className='Temperature'>Humidity</p>
                    <p className='TemperatureInfo'>80%</p>
                </div>
            </div>
        </div>
    )
}

export default DashboardEnvData;